// Client-facing playback for the coach's recorded session (single combined video).
export function CoachRecordingPlayer({ recordingUrl, text, coachName }) {
  return (
    <div data-testid="coach-recording-player">
      <div className="relative bg-black aspect-video border border-[#C9A227]/40 overflow-hidden">
        <video src={recordingUrl} controls playsInline preload="metadata"
               className="w-full h-full object-contain" data-testid="coach-recording-video" />
        <div className="absolute top-2 right-2 overline px-2 py-1 bg-[#C9A227] text-[#050A08] font-bold">● Coach breakdown</div>
      </div>
      <div className="mt-5 border-l-2 border-[#C9A227] pl-5">
        <div className="overline" style={{ color: "#C9A227" }}>Coach feedback{coachName ? ` · ${coachName}` : ""}</div>
        {text ? (
          <p className="text-white/85 mt-2 whitespace-pre-wrap" data-testid="coach-response-text">{text}</p>
        ) : (
          <p className="text-white/50 mt-2">Press play to watch your coach's narrated, marked-up breakdown.</p>
        )}
      </div>
    </div>
  );
}
